import { useRef } from "react";

import { Menu, ToolIcon } from "@theorgchartdev/storybook";
import { getHoverTipContent } from "@/Utils/Misc";
import {
  CheckBoxCellControlDisabled,
  InsertCol,
  DeleteColumn
} from "@/appComponents/Blocks/Composites/LayoutHoverToolbar/Utils";
import { appstr } from "@coreapp/utils/appstr";
import { GetWSMgr } from "@/Utils/StateLib";
import { enumContainerType, enumHierarchyTypes } from "@coreapp/constants";

export const InsertColumnMenu = props => {
  const openCtrlRef = useRef(null);
  const wsMgr = GetWSMgr();
  const layout = wsMgr?.GetBLELayout();
  const isGroupBox =
    layout?.GetContainerType() === enumContainerType.standardmrb &&
    layout?.GetHierarchyType() === enumHierarchyTypes.grouping;

  if (isGroupBox) {
    return (
      <ToolIcon
        name={"boxcolumns"}
        size={"medium-small"}
        disabled={true}
        onClick={() => {}}
        style={{ opacity: 0.4 }}
        tooltipProps={{ message: appstr("Group box layouts cannot have columns") }}
      />
    );
  }

  const BLEInsertOptions = [
    {
      value: "insertcolleft",
      clickHandler: InsertCol,
      disabled: CheckBoxCellControlDisabled
    },
    {
      value: "insertcolright",
      clickHandler: () => InsertCol(false),
      disabled: CheckBoxCellControlDisabled,
      divider: true
    },
    {
      value: "deletecols",
      clickHandler: DeleteColumn,
      disabled: CheckBoxCellControlDisabled
    }
  ];

  return (
    <Menu
      openCtrlRef={openCtrlRef}
      optionSize={"small"}
      stayOpenOnOptionSelect
      trigger={
        <ToolIcon
          name={"boxcolumns"}
          size={"medium-small"}
          tooltipProps={{
            ...getHoverTipContent("Column actions"),
            referenceOpenCtrlRef: openCtrlRef
          }}
        />
      }
      dataTestId={`${props?.dataTestIdPrefix}-insert-column-menu`}
      options={BLEInsertOptions.map(item => {
        return {
          ...item,
          label: appstr(item.value),
          disabled: item.disabled(item.value),
          dataTestId: `${props?.dataTestIdPrefix}-insert-column-menu-${item.value}`
        };
      })}
    />
  );
};
